@if (clusters && clusters.length > 0) {
<div class="dashboard">
  <h1 translate>dashboard.dashboard</h1>
  <p translate>dashboard.info</p>

  <div class="dashboard__entities">
    <app-entity-card
      [count]="'workspacesCount' | statisticsSum : statistics"
      [label]="'dashboard.entity.workspaces' | translate"
    ></app-entity-card>
    <app-entity-card
      [count]="'usersCount' | statisticsSum : statistics"
      [label]="'dashboard.entity.users' | translate"
    ></app-entity-card>

    @if (!(('totalDeploymentsCount' | statisticsSum : statistics) | isNaN)) {
    <app-entity-card
      [count]="'totalDeploymentsCount' | statisticsSum : statistics"
      [label]="'dashboard.entity.deployments' | translate"
    ></app-entity-card>
    } @else {
    <app-entity-card
      [count]="'kserveDeploymentsCount' | statisticsSum : statistics"
      [label]="'dashboard.entity.managedDeployments' | translate"
    ></app-entity-card>
    <app-entity-card
      [count]="'externalDeploymentsCount' | statisticsSum : statistics"
      [label]="'dashboard.entity.externalDeployments' | translate"
    ></app-entity-card>
    <app-entity-card
      [count]="'registrationDeploymentsCount' | statisticsSum : statistics"
      [label]="'dashboard.entity.registrationDeployments' | translate"
    ></app-entity-card>
    }


  </div>



  <h2 translate>dashboard.clusters</h2>

  <div
    class="dashboard__clusters"
  >
    @for (cluster of clusters; track cluster.clusterId) {
    <app-cluster-card [cluster]="cluster"></app-cluster-card>
    }
  </div>
</div>
} @else if (clusters && clusters.length === 0) {
<app-dashboard-empty></app-dashboard-empty>
}
